import React, { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import theme from "../theme";

interface PageHeaderProps {
  title: string;
  children?: ReactNode
}

export default (props: PageHeaderProps) => (
  <Box display="flex" justifyContent="space-between" borderBottom={1} borderColor='grey.300' sx={{
    padding: theme.spacing(2),
    backgroundImage: 'linear-gradient(#FFFFFF, #FDFDFD)',
    backgroundColor: '#FDFDFD'
  }}>
    <Typography variant="h5">{props.title}</Typography>
    {props.children}
  </Box>
)